module.exports = __webpack_public_path__ + "static/img/performance3.8a84b4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/imgs/performance3.jpg
// module id = O/5G
// module chunks = 1